<template>
    <div id="app" class="app">
        <router-view :activityData="activityData"/>
        <base-component :baseData="baseData" v-if="baseData"></base-component>
    </div>
</template>

<script>

import COVER from '../../utils/COVER'
import BaseComponent from '../../components/Base'

export default {
    data() {
        return {
            activityData: null,
            baseData: null
        }
    },
    created() {
        this.aid = this.$route.query.id || ''
        const html = this.$route.query.html || ''
        if (html === 'grey') {
          document.querySelector('html').setAttribute('class', 'html-grey');
        }
        this.getActivityData();
    },
    components: {
        BaseComponent
    },
    methods: {
        getActivityData() {
            COVER.$get('/activity/config', {
                aid: this.aid
            }).then((res) => {
                if(res.errno == 0) {
                    let data = res.data
                    document.title = data.title
                    this.activityData = Object.assign({title: data.title, isAppShow: data.isAppShow}, data.templateConfig)
                    this.baseData = Object.assign({
						isAppShow: data.isAppShow,
						music: data.music,
						share: data.share,
						isEnd: data.serverTime >= new Date(data.endTime).getTime(),
					}, data.openApp || {});
                } else {

                }
            })
        },
    }
}
</script>

<style lang="less">
.html-grey {
  -webkit-filter: grayscale(100%); 
	-moz-filter: grayscale(100%); 
	-ms-filter: grayscale(100%); 
	-o-filter: grayscale(100%); 
	filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
}
</style>>